import { ReactNode } from 'react';

import { Body, Card, Title } from './styles';

interface ChartCardProps {
  title: string;
  children: ReactNode;
  fullWidth?: boolean;
  ariaLabel?: string;
}

export function ChartCard({
  title,
  children,
  fullWidth,
  ariaLabel,
}: ChartCardProps): JSX.Element {
  return (
    <Card sx={fullWidth ? { gridColumn: '1 / -1' } : undefined}>
      <Title>{title}</Title>
      <Body role="img" aria-label={ariaLabel || title}>
        {children}
      </Body>
    </Card>
  );
}
